import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { ImageContainer } from "../../../shared/components/ImageContainer";
import { DocumentsIcon, NotesIcon } from "../../../assets/icons/icons";
import { CloseSharp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

type Props = {
  activeDialog: any;
  handleDialog?: any;
};

const ProductTypeDialog: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  useEffect(() => {}, [props?.activeDialog]);

  return (
    props?.activeDialog && (
      <>
        <Box
          sx={{
            position: "fixed", // Ensure the backdrop covers the entire screen
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0, 0, 0, 0.60)",
            zIndex: 5000, // Set zIndex below the dialog
          }}
        >
          {/* Apply blur effect to only this background */}
          <Box
            sx={{
              width: "100vw",
              height: "100vh",
              border: "1px solid red",
              bgcolor: "rgba(0, 0, 0, 0.60)",
              filter: "blur(62px)",
            }}
          />
        </Box>

        <Box
          sx={{
            position: "fixed", // Position the dialog above the backdrop
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)", // Center the dialog
            zIndex: 6000, // Higher zIndex than the backdrop
          }}
        >
          <Box
            sx={{
              width: "610px",
              maxWidth: "610px",
              padding: "24px 24px 0 24px",
              height: "auto",
              bgcolor: "#1B1B1B",
              borderRadius: "24px",
              border: "1px solid #3D3D3D",
              cursor: "default",
              position: "relative",
            }}
          >
            {/* Dialog content */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
              }}
            >
              {/* Title section */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: "text.secondary",
                    fontSize: "24px",
                    fontWeight: "600",
                    lineHeight: "28px",
                  }}
                >
                  Select Product Type
                </Typography>
                <CloseSharp
                  onClick={(e) => {
                    e.stopPropagation();
                    props?.handleDialog();
                    navigate(-1);
                  }}
                  sx={{
                    position: "absolute",
                    right: "24px",
                    top: "24px",
                    cursor: "pointer",
                    color: "white",
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "60px",
                  mt: "50px",
                  mb: "50px",
                }}
              >
                {/* Product box */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <Box
                    onClick={() => {
                      props?.handleDialog("PRODUCT");
                    }}
                    sx={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #3D3D3D",
                      cursor: "pointer",
                    }}
                  >
                    <ImageContainer title="document">
                      {DocumentsIcon}
                    </ImageContainer>
                  </Box>

                  <Typography sx={{ color: "text.secondary" }} variant="body1">
                    Product
                  </Typography>
                </Box>

                {/* Components box */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <Box
                    onClick={() => {
                      props?.handleDialog("COMPONENT");
                    }}
                    sx={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #3D3D3D",
                      cursor: "pointer",
                    }}
                  >
                    <ImageContainer title="document">
                      {NotesIcon}
                    </ImageContainer>
                  </Box>

                  <Typography sx={{ color: "text.secondary" }} variant="body1">
                    Components
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    )
  );
};

export default ProductTypeDialog;
